<h2 class="margin-bottom-32">How is the tax calculated?</h2>

<div class="tax-container" fxLayout="column" fxLayoutGap="12px" fxLayoutAlign="center center" fxLayout.lt-md="column">
  <div
    fxFlex
    class="selection__box"
    [class.selection__box-selected]="tax?.charge_type === 'fixed'"
    fxLayout="column"
    fxFill
    fxLayoutGap="16px"
    (click)="tax.charge_type = 'fixed'">
    <div fxLayout fxLayoutGap="12px">
      <strong fxFlex>Fixed Fee Amount</strong>
    </div>
    <div class="text__small">A flat rate that is added to the price.</div>
  </div>

  <div
    fxFlex
    class="selection__box"
    [class.selection__box-selected]="tax?.charge_type === 'percent'"
    fxLayout="column"
    fxFill
    fxLayoutGap="16px"
    (click)="tax.charge_type = 'percent'">
    <div fxLayout fxLayoutGap="12px">
      <strong fxFlex>Percentage</strong>
    </div>

    <div class="text__small">A percentage amount of a certain amount that is added to the price.</div>
  </div>
</div>

<div style="margin-top: 32px" fxLayout fxLayoutGap="24px" fxLayoutAlign="end center">
  <sbnb-button
    data-intercom-target="direct-tax-type-back"
    label="Back"
    type="secondary"
    (clicked)="back()"></sbnb-button>

  <sbnb-button
    [disabled]="!tax.charge_type"
    data-intercom-target="direct-tax-type-next"
    label="Continue"
    (clicked)="progress()"></sbnb-button>
</div>
